import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../components/Header";
import Paiement from "../../../components/paiement";
import {useRouter} from 'next/router';
import Footer from "../components/Footer";
import Loader from "../loader";
import {Button, Result} from "antd";
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import { loadPaiementConfig } from "../../../services/paiementLauncher";

class PaiementPage extends Component{

    state={
        config:null
    }

    componentDidMount()
    {
        const router=this.props.router
        const context=this.props.context
        const {org}=context

        if(context.page.config)
        {
            this.setState({config:context.page.config})

        }else
        {
            try{
                // Pas de config lisible (panier trop volumineux pour l’URL, stockage
                // de session cloisonné par site hôte, valeur corrompue) : `loadPaiementConfig`
                // renvoie null sans lever, donc le catch ci-dessous ne peut plus jouer.
                // Sans ce repli, le donateur resterait devant une page vide.
                const config=loadPaiementConfig(org)
                if(config){
                    this.setState({config})
                }else if(typeof window !== "undefined"){
                    window.location.href=org.BASE_WEB_URL
                }else{
                    router.replace(org.BASE_WEB_URL)
                }
            }catch (e){

                if(typeof window !== "undefined"){
                    window.location.href=org.BASE_WEB_URL
                }else{
                    router.replace(org.BASE_WEB_URL)
                }

            }
        }
    }

    render(){
        const context=this.props.context

        const {org}=context
        let title=t`Paiement ${org.name}`
        let description=t`Paiement ${org.name}`

        if(this.state.config && this.state.config?.update){
            title=description=t`Modification - ${this.state.config.paiement.name}`
        }


        if(this.props.loading){
            return (
                <div className="travel-page travel-page--home">
                    <Meta context={context} title={title} description={description}/>
                    <Loader/>
                </div>
            )
        }


        if(this.state.config && this.state.config?.update && this.state.config?.paiement?.finalized){
            return (
                <div className="travel-page travel-page--home" style={{minHeight: "50vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <Result
                        style={{maxWidth: 600}}
                        status={"warning"}
                        title={t`Ce lien est expiré !`}
                        subTitle={t`Pour toute question contactez directement votre responsable.`}
                        extra={context.render !== "embed" ? (
                            <Button href={org.BASE_WEB_URL}><Trans>Retourner à la page d'accueil</Trans></Button>
                        ) : undefined}
                    />
                </div>
            )
        }

        return (
            <div className="travel-page travel-page--home">
                <Meta context={context} title={title} description={description}/>
                <Header context={context}/>
                <div style={{marginTop: 20}}>
                    {this.state.config && <Paiement context={context} config={this.state.config} travel={context.travel}/>}
                </div>
                <Footer mini context={context}/>
            </div>
        )
    }
}

function withHook(Comp) {
    return (props) => {
        var router = useRouter()
        return <Comp router={router} {...props}/>
    }
}

export default withHook(PaiementPage)
